import React from 'react';

function Header() {
  return (
    <header className="text-center py-6">
      <h1 className="text-4xl font-bold">Interactive Webpages Tools Dashboard</h1>
      <p className="text-sm pt-3 text-gray-600 dark:text-gray-400">Quick access to our campaign's tools and resources</p>
    </header>
  );
}

export default Header;
